module.exports = __webpack_public_path__ + "img/access_site_settings.0a91ca21.png";